import type React from 'react';
import { useRef } from 'react';

export function Instrument({
  children,
  onInitialRender,
}: {
  children: React.ReactNode;
  onInitialRender: () => unknown;
}) {
  const once = useRef(false);
  if (!once.current) {
    once.current = true;
    onInitialRender();
  }

  return <>{children}</>;
}
